import selectedPolicesActions from '../actions/selectedPolices.actions';

const selectedPolicesReducer = (state, action) => {
  switch (action.type) {
    case selectedPolicesActions.SERVICE_REQUEST_POLICIES_SELECTED:
      return Object.assign({}, state, {
        ids: action.ids,
      });
    default:
      return state;
  }
};

export default selectedPolicesReducer;
